import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { AUTH_ACTIONS } from 'src/containers/auth-container/actions/AuthActions';
import { InsuranceSlabDefaultProps } from 'src/containers/insurance-slab-container/InsuranceSlabPropTypes';
import { INSURANCE_SLAB_ACTIONS } from '../actions/insuranceSlabActions';
import { cloneDeep } from 'lodash-es';

const initialState = () => ({
    currentRecord: cloneDeep(InsuranceSlabDefaultProps),

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        // SEARCH
        case INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // UPSERT
        case INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // RESET
        case INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_RESET: {
            return initialState();
        }

        // LOGOUT
        case AUTH_ACTIONS.LOGOUT:
            return {
                ...initialState(),
            };

        default:
            return state;
    }
};
